// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__1f5tu","loading-wrapper":"Loading_loading-wrapper__2NoDz","loadingWrapper":"Loading_loadingWrapper__15jiX"};